import * as PIXI from "pixi.js";
import { Spine } from "pixi-spine";

function initCanvas(
  id,
  { h: displayH, w: displayW }, // canvas画布宽高
  path, // spine项目文件中导出的json路径
  { h: animationH, w: animationW, x: animationX, y: animationY } // 动画的运行宽高和xy轴的偏移
) {
  document.getElementById(id).innerHTML = "";
  const clientHeight = document.documentElement.clientHeight;
  const clientWidth = document.documentElement.clientWidth;
  const vmax = Math.max(clientHeight, clientWidth);
  const element = new PIXI.Application({
    antialias: true,
    transparent: true,
    width: clientWidth * displayW,
    height: vmax * displayH,
  });

  // 解决canvas无法触控滑动的问题
  element.renderer.plugins.interaction.autoPreventDefault = false;
  element.renderer.view.style.touchAction = "auto";

  document.getElementById(id).appendChild(element.view);
  element.loader
    .add("node", window.location.href.split("/")[0] + path)
    .load(function(_loader, resources) {
      const animation = new Spine(resources.node.spineData);

      element.stage.addChild(animation);
      if (animation.state.hasAnimation("animation")) {
        animation.state.setAnimation(0, "animation", true);
        animation.width =
          animationW > 10 ? animationW : clientWidth * animationW;
        animation.height = animationH > 10 ? animationH : vmax * animationH;
        animation.x = animationX > 10 ? animationX : clientWidth * animationX;
        animation.y = animationY > 10 ? animationY : vmax * animationY;
      }
      element.start();
    });
}

function carouselSlideHandler(selector, ref) {
  var box = document.querySelector(selector);
  var startPoint = 0;
  var stopPoint = 0;
  var resetPoint = function() {
    startPoint = 0;
    stopPoint = 0;
  };
  box.addEventListener("touchstart", function(e) {
    startPoint = e.changedTouches[0].pageX;
  });
  box.addEventListener("touchmove", function(e) {
    stopPoint = e.changedTouches[0].pageX;
  });
  box.addEventListener("touchend", function() {
    if (stopPoint == 0 || startPoint - stopPoint == 0) {
      resetPoint();
      return;
    }
    if (startPoint - stopPoint > 0) {
      resetPoint();
      ref.next();
      return;
    }
    if (startPoint - stopPoint < 0) {
      resetPoint();
      ref.prev();
      return;
    }
  });
}

export default {
  initCanvas,
  carouselSlideHandler,
};



// WEBPACK FOOTER //
// ./src/components/util.js